import React, { useContext, useState } from "react";
import {
  UsersIcon,
  ChatBubbleLeftEllipsisIcon,
} from "@heroicons/react/24/outline";
import ReactTooltip from "react-tooltip";
import { NavbarUser } from "../navigation/NavbarUser";
import "react-circular-progressbar/dist/styles.css";
import {
  CharacterNavbar,
  MenuCloseSession,
} from "../navigation/CharacterNavbar";
import { LevelData, LevelProgressbar, Title } from "./LevelUser";
import { LastActivityComponent } from "./lastActivity";
import { DisclosureInviteFriends } from "../navigation/disclosure/Friends/InviteFriends";
import { Notifications } from "../notifications/Notifications";
import { FriendsViewContext } from "../../context/Disclosures/friends/friendsContext";
/* import { useChat } from "../../context/ChatIaContext/ChatIaContext"; */

function getCurrentDimension() {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

export function DashboardMyCredit(props) {
  /* const { toggleChat } = useChat(); */
  const { updateFriendsView } = useContext(FriendsViewContext);
  const [tooltip4, showTooltip4] = useState(true);
  const [screenSize, setScreenSize] = React.useState(getCurrentDimension());
  const userDatas = [{ firstName: props.name }, { balance: props.balance }];

  const openDisclosureInviteFriends = () => {
    updateFriendsView({
      openDisclosure: true,
    });
  };

  React.useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, []);

  return (
    <>
      <div className="flex md:py-4 h-screen">
        {/* Static sidebar for desktop */}
        <NavbarUser
          disclosure={props.disclosure}
          current={props.current}
          disclosures={props?.disclosures}
          creditInfo={props?.creditInfo}
          due={props?.due} />
        <div className="flex flex-col min-w-0 flex-1 h-screen md:h-full">
          <div className="flex-1 flex">
            <main className="relative flex-1 max-h-full md:rounded-xl bg-purpleLight mr-0 md:mr-4 xl:mr-0">
              {/* Start main area*/}
              <div className="pt-2  md:py-8 lg:px-8 md:h-full">
                <div className="h-full">
                  {/*Sección para mobile screen*/}
                  <div className="pt-8 pb-0 md:hidden px-6">
                    <div className="flex justify-between">
                      <div className="flex gap-2">
                        <div className="grid content-center">
                          <CharacterNavbar name={userDatas[0].firstName} />
                        </div>
                        <div className="py-2 text-lg">
                          <div className="text-grayP">Hola</div>
                          <div className="font-bold">
                            {userDatas[0].firstName}
                          </div>
                        </div>
                      </div>
                      <div className="grid content-center">
                        <UsersIcon onClick={openDisclosureInviteFriends} className="w-6 h-auto" />
                      </div>
                    </div>
                    <div className="text-4xl font-bold pt-4">{props.title}</div>
                  </div>
                  {/*Final sección para mobile screen*/}
                  {/*Sección para Tablet screen*/}
                  <div className="hidden md:flex mx-6 lg:mx-0 justify-between">
                    <div className="">
                      <h1 className="block font-bold text-3xl md:text-5xl pr-2">
                        {props.title}
                      </h1>
                    </div>
                    <div className="hidden md:flex gap-2">
                      <div className="hidden relative xl:grid h-full content-center text-grayP cursor-pointer">
                        {/*Icono notificaciones*/}
                        <Notifications device={"desktop"}></Notifications>
                      </div>
                      {/* Imagen Astronauta para versión Tablet*/}
                      <div className="xl:hidden grid content-center">
                        <CharacterNavbar name={userDatas[0].firstName} />
                      </div>
                    </div>
                  </div>
                  {/*Final Sección para Tablet screen*/}
                  <div className="h-full">
                    <div
                      id="cards-container-mobile"
                      className="cards-container"
                    >
                      {props.main}
                    </div>
                  </div>
                </div>
              </div>
            </main>

            <aside className="hidden pt-8 relative xl:flex xl:flex-col flex-shrink-0 xl:w-90 z-0 pr-6 2xl:pr-10 pl-6">
              {/* Start secondary column (hidden on smaller screens) */}
              <div className="h-full">
                <div className="h-full grid content-between">
                  <div className="h-14">
                    <div className="flex justify-between h-12">
                      <MenuCloseSession />

                      <div className="relative grid content-center text-grayP">
                        <div className="flex">
                          {/*Icono invitar amigos*/}
                          <div className="grid content-center justify-center mr-2">
                            <DisclosureInviteFriends />
                          </div>
                          {/*Icono chatbox*/}
                          <a
                            href="https://api.whatsapp.com/send/?phone=+573124008320&text=Hola, necesito un asesor"
                            target="__blank"
                            className="grid content-center justify-center mr-2"
                          >
                            <ChatBubbleLeftEllipsisIcon
                              data-tip="React-tooltip"
                              data-for="chat"
                              className="w-6 h-auto cursor-pointer"
                              /* onClick={toggleChat} */
                            />
                            <ReactTooltip
                              place="top"
                              id="chat"
                              type="dark"
                              effect="solid"
                              className="font-bold"
                            >
                              Hablar con un asesor
                            </ReactTooltip>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="py-4">
                    <div className="flex">
                      <div className="block font-bold text-lg md:text-3xl pr-2">
                        Hola
                        <div>{userDatas[0].firstName}</div>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-r-full">
                    <div className="w-full grid mx-auto p-4 bg-purpleLight rounded-xl">
                      <div className="mx-auto">
                        <Title />
                      </div>
                      <div className="sm pt-4 w-24 mx-auto">
                        <LevelProgressbar />
                      </div>
                      <div className="grid py-2 pl-2">
                        <LevelData />
                      </div>
                    </div>
                  </div>
                  {/* Init component Last activity user */}
                  <LastActivityComponent></LastActivityComponent>
                  {/* End component Last activity user */}
                </div>
              </div>
              {/* End secondary column */}
            </aside>
          </div>
        </div>
      </div>
    </>
  );
}
